"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodSelect = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'payment-method-select';
const PaymentMethodSelect = (props) => {
    const { icon, title, field, select, disabled, modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        disabled ? 'disabled' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames, onClick: () => {
            if (disabled)
                return;
            select();
        } },
        react_1.default.createElement("div", { className: `${className}__icon` },
            react_1.default.createElement(Icon_1.Icon, { name: icon })),
        react_1.default.createElement("div", { className: `${className}__title` }, title),
        react_1.default.createElement("div", { className: `${className}__field` }, field)));
};
exports.PaymentMethodSelect = PaymentMethodSelect;
//# sourceMappingURL=index.js.map